var _rect, _rect2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 31,
    height: 31,
    rx: 5.5,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 31,
    height: 31,
    rx: 5.5,
    stroke: "#346C75"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.6666 9.33398H11.3333C10.8029 9.33398 10.2942 9.5447 9.9191 9.91977C9.54403 10.2948 9.33331 10.8036 9.33331 11.334V12.114C9.33322 12.3893 9.38996 12.6616 9.49998 12.914V12.954C9.59417 13.168 9.72757 13.3624 9.89331 13.5273L14 17.6073V22.0007C13.9998 22.1139 14.0284 22.2254 14.0832 22.3246C14.1381 22.4237 14.2172 22.5073 14.3133 22.5673C14.4194 22.6331 14.5418 22.6677 14.6666 22.6673C14.771 22.6667 14.8738 22.6416 14.9666 22.594L17.6333 21.2607C17.7433 21.2053 17.8357 21.1205 17.9004 21.0158C17.9651 20.911 17.9996 20.7904 18 20.6673V17.6073L22.08 13.5273C22.2457 13.3624 22.3791 13.168 22.4733 12.954V12.914C22.5925 12.6636 22.6584 12.3912 22.6666 12.114V11.334C22.6666 10.8036 22.4559 10.2948 22.0809 9.91977C21.7058 9.5447 21.1971 9.33398 20.6666 9.33398ZM16.86 16.8607C16.7982 16.9229 16.7493 16.9968 16.7161 17.078C16.683 17.1593 16.6661 17.2462 16.6666 17.334V20.254L15.3333 20.9207V17.334C15.3338 17.2462 15.317 17.1593 15.2838 17.078C15.2506 16.9968 15.2018 16.9229 15.14 16.8607L11.6066 13.334H20.3933L16.86 16.8607ZM21.3333 12.0007H10.6666V11.334C10.6666 11.1572 10.7369 10.9876 10.8619 10.8626C10.9869 10.7376 11.1565 10.6673 11.3333 10.6673H20.6666C20.8435 10.6673 21.013 10.7376 21.1381 10.8626C21.2631 10.9876 21.3333 11.1572 21.3333 11.334V12.0007Z",
    fill: "#346C75"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/filter.2e8337f8aad893adae802cf792c307d6.svg";
export { ForwardRef as ReactComponent };